module.exports = __webpack_public_path__ + "static/media/Ο ΚΟΣΜΟΣ ΤΩΝ ΚΩΦΩΝ.43e6b91d.vtt";